// work process
import process1 from "./assets/working-process-1.png";
import process2 from "./assets/working-process-2.png";
import process3 from "./assets/working-process-3.png";
import process4 from "./assets/working-process-4.png";

// web development services icons
import ecomWebIcon from "./assets/icons/online-shopping.png";
import socialWebIcon from "./assets/icons/socialmedia.png";
import landingWebIcon from "./assets/icons/landing-page.png";
import customWebIcon from "./assets/icons/software-development.png";

// app development services icons
import iosAppIcon from "./assets/icons/ios-development.png";
import androidAppIcon from "./assets/icons/android-development.png";
import flutterAppIcon from "./assets/icons/flutter-development.png";
import hybridAppIcon from "./assets/icons/hybrid-app-development.png";

// clients
import client1 from "./assets/client-1.png";
import client2 from "./assets/client-2.png";
import client3 from "./assets/client-3.png";
import client4 from "./assets/client-4.png";

// logo
import logo from "./assets/logo/logo.png";

export { logo };

// client details
export const clientDetails = {
  phone: "917417918274",
  email: "synatxsquad@gmail.com",
  address: "4th floor, Yashodhra arcade, Mohanpura, Roorkee, District- Haridwar, Uttarakhand",
};

// landing page header links
export const landingPageHeaderLinks = [
  {
    id: 1,
    title: "Home",
    link: "banner",
  },
  {
    id: 2,
    title: "About Us",
    link: "about-us",
  },
  {
    id: 3,
    title: "Services",
    link: "services",
  },
  // {
  //   id: 4,
  //   title: "Contact Us",
  //   link: "contact",
  // },
];

// website pages
export const websitePagesLinks = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },
  // {
  //   id: 2,
  //   title: "Industries",
  //   link: "/industries",
  // },
  {
    id: 3,
    title: "Our Services",
    link: "/services",
  },
];

// working process
export const workingProcess = [
  {
    id: 1,
    title: "In-Depth Consultation",
    description: "Understand your needs, discuss goals.",
    img: process1,
  },
  {
    id: 2,
    title: "Strategic Planning",
    description: "Create roadmap, define KPIs, set timeline.",
    img: process2,
  },
  {
    id: 3,
    title: "Design and Development",
    description: "Design visually stunning, develop functional website",
    img: process3,
  },
  {
    id: 4,
    title: "Rigorous Testing",
    description: "Ensure optimal performance, compatibility, security",
    img: process4,
  },
];

// web development services
export const webDevelopmentServices = [
  {
    id: 1,
    title: "E-commerce Websites",
    icon: ecomWebIcon,
    img: require("./assets/landingpage-services-imgs/ecommerce.webp"),
    description:
      "We create powerful e-commerce websites that enhance customer engagement, streamline business operations, and drive sustainable revenue growth.",
  },
  {
    id: 2,
    title: "Social Media Websites",
    icon: socialWebIcon,
    img: require("./assets/landingpage-services-imgs/socialmedia.webp"),
    description:
      "Developing dynamic and engaging social media websites designed to foster community interaction, boost brand awareness, and encourage user loyalty.",
  },
  {
    id: 3,
    title: "Landing Websites",
    icon: landingWebIcon,
    img: require("./assets/landingpage-services-imgs/landing.webp"),
    description:
      "Crafting high-conversion landing pages that grab attention and drive meaningful action, tailored to showcase your brand and optimize results.",
  },
  {
    id: 4,
    title: "Custom Websites",
    icon: customWebIcon,
    img: require("./assets/landingpage-services-imgs/customweb.webp"),
    description:
      "Building bespoke websites designed specifically for your business, combining innovative design and seamless functionality for a remarkable online presence.",
  },
];

// app development services
export const appDevelopmentServices = [
  {
    id: 1,
    title: "iOS App Development",
    icon: iosAppIcon,
    img: require("./assets/landingpage-services-imgs/ios.webp"),
    description:
      "We create exceptional iOS apps using Swift and Objective-C, delivering seamless performance, modern design, and enhanced user engagement.",
  },
  {
    id: 2,
    title: "Android App Development",
    icon: androidAppIcon,
    img: require("./assets/landingpage-services-imgs/android.webp"),
    description:
      "Our Android apps, crafted with Java and Kotlin, are tailored to your business vision, offering robust features and outstanding user experiences.",
  },
  {
    id: 3,
    title: "Flutter App Development",
    icon: flutterAppIcon,
    img: require("./assets/landingpage-services-imgs/flutter.webp"),
    description:
      "Leverage Flutter’s single codebase to build responsive apps for iOS and Android, ensuring efficiency without compromising on quality.",
  },
  {
    id: 4,
    title: "Hybrid App Development",
    icon: hybridAppIcon,
    img: require("./assets/landingpage-services-imgs/hybrid.webp"),
    description:
      "Our hybrid apps deliver seamless functionality across platforms, combining native performance with versatile design for an enhanced user experience.",
  },
];

// all services
export const allServices = [
  {
    id: 1,
    img1: require("./assets/services-details/arvr1.webp"),
    img2: require("./assets/services-details/arvr2.webp"), 
    title: "VR and AR Development",
    smallPara:
      "Virtual Reality (VR) and Augmented Reality (AR) are transformative technologies that create immersive and interactive experiences. VR transports users to entirely virtual environments, while AR overlays digital elements onto the real world. These technologies are revolutionizing industries such as gaming, education, healthcare, and retail.",
    keyBenefits: [
      "Immersive and engaging user experiences.",
      "Enhanced training and simulation capabilities.",
      "Improved customer engagement and interaction.",
      "Innovative solutions for real-world problems.",
    ],
    detailsPageContent: {
      firstPara: `Virtual Reality (VR) and Augmented Reality (AR) are reshaping how we interact with digital content, offering immersive and interactive experiences that bridge the gap between the physical and virtual worlds. From gaming and entertainment to education and healthcare, these technologies are driving innovation across industries.
          \n
          Our VR and AR development services focus on creating cutting-edge applications that deliver engaging and impactful experiences. Whether you need a VR training simulation or an AR-based retail solution, we have the expertise to bring your vision to life.`,
      servicesSection: `We provide end-to-end VR and AR development services, including concept design, 3D modeling, and application development. Our team is proficient in using industry-leading tools and platforms, such as Unity, Unreal Engine, and ARKit, to create high-quality immersive experiences.
          \n
          Our services include VR/AR strategy development, content creation, and integration with existing systems. We work closely with you to deliver customized solutions that meet your specific needs and drive innovation in your industry.`,
    },
  },
  {
    id: 2,
    img1: require("./assets/services-details/chatbot1.webp"), 
    img2: require("./assets/services-details/chatbot2.webp"), 
    title: "Chatbot Development",
    smallPara:
      "Chatbots are AI-powered tools that enable businesses to automate customer interactions, provide instant support, and streamline operations. They can be integrated into websites, messaging platforms, and mobile apps to deliver personalized and efficient communication.",
    keyBenefits: [
      "24/7 customer support and engagement.",
      "Automated responses to common queries.",
      "Improved customer satisfaction and retention.",
      "Seamless integration with existing systems.",
    ],
    detailsPageContent: {
      firstPara: `Chatbots are revolutionizing customer service by providing instant, automated responses to user queries. Powered by artificial intelligence, chatbots can handle a wide range of tasks, from answering frequently asked questions to processing orders and booking appointments.
          \n
          Our chatbot development services focus on creating intelligent, conversational agents that enhance customer engagement and streamline business operations. Whether you need a simple FAQ bot or a complex AI-driven assistant, we have the expertise to deliver a solution that meets your needs.`,
      servicesSection: `We offer comprehensive chatbot development services, including natural language processing (NLP), machine learning integration, and multi-platform deployment. Our team is experienced in building chatbots for websites, messaging apps, and mobile platforms, ensuring seamless integration and optimal performance.
          \n
          Our services include chatbot strategy development, conversational design, and ongoing optimization. We work closely with you to create a chatbot that aligns with your business goals and delivers a superior customer experience.`,
    },
  },
  {
    id: 3,
    img1: require("./assets/services-details/app-development1.webp"),
    img2: require("./assets/services-details/app-development2.webp"),
    title: "App Development",
    smallPara:
      "Mobile applications have become an integral part of our daily lives, transforming the way we communicate, consume information, and conduct business. The development of mobile apps requires a unique set of skills and considerations, as compared to website development.",
    keyBenefits: [
      "Cross-platform compatibility for iOS and Android.",
      "User-centric design for better engagement.",
      "Robust performance and offline capabilities.",
      "Advanced security features for data protection.",
    ],
    detailsPageContent: {
      firstPara: `Mobile applications have revolutionized the way we interact with technology, providing seamless access to services, information, and entertainment on the go. Developing a successful mobile app requires a deep understanding of user behavior, platform-specific guidelines, and performance optimization.
          \n
          Our app development process involves creating native and cross-platform apps that deliver exceptional user experiences. We focus on intuitive design, smooth navigation, and robust functionality to ensure your app stands out in the competitive market.`,
      servicesSection: `Our app development services cover the entire lifecycle, from concept to deployment and maintenance. We specialize in building apps for iOS and Android platforms, utilizing technologies like Swift, Kotlin, React Native, and Flutter. Our team ensures your app is optimized for performance, security, and scalability, providing a seamless experience for your users.
          \n
          Whether you need a consumer-facing app or an enterprise solution, we tailor our approach to meet your specific requirements, delivering high-quality apps that drive engagement and achieve your business goals.`,
    },
  },
  {
    id: 4,
    img1: require("./assets/services-details/generative-ai-1.webp"),
    img2: require("./assets/services-details/generative-ai-2.webp"),
    title: "Artificial Intelligence Development",
    smallPara:
      "Artificial Intelligence (AI) is transforming industries by enabling machines to perform tasks that traditionally required human intelligence. From predictive analytics to natural language processing, AI solutions are driving innovation and efficiency across various sectors.",
    keyBenefits: [
      "Automation of repetitive tasks and processes.",
      "Enhanced decision-making with predictive analytics.",
      "Improved customer experiences through personalization.",
      "Scalable solutions for complex problems.",
    ],
    detailsPageContent: {
      firstPara: `Artificial Intelligence (AI) is revolutionizing the way businesses operate, offering powerful tools for automation, data analysis, and decision-making. From machine learning algorithms to natural language processing, AI technologies are driving innovation and efficiency across industries.
          \n
          Our AI development services focus on creating intelligent solutions that automate processes, analyze data, and deliver actionable insights. Whether you need a recommendation engine or a predictive analytics model, we have the expertise to build AI-driven solutions that meet your needs.`,
      servicesSection: `We offer comprehensive AI development services, including machine learning, deep learning, and natural language processing. Our team is experienced in using AI frameworks and tools, such as TensorFlow, PyTorch, and OpenAI, to develop custom solutions that address your specific challenges.
          \n
          Our services include AI strategy development, model training, and integration with existing systems. We work closely with you to deliver AI solutions that enhance your operations, improve decision-making, and drive business growth.`,
    },
  },
  {
    id: 5,
    img1: require("./assets/services-details/web-development1.webp"),
    img2: require("./assets/services-details/web-development2.webp"),
    title: "Web Development",
    smallPara:
      "In today's interconnected world, website applications have become an integral part of our daily lives. From e-commerce platforms to social media networks, from educational resources to government services, these digital tools have revolutionized the way we interact, communicate, and conduct business.",
    keyBenefits: [
      "Responsive and user-friendly design.",
      "Custom-built solutions tailored to your business needs.",
      "Secure and scalable architecture.",
      "Seamless integration with third-party tools and APIs.",
    ],
    detailsPageContent: {
      firstPara: `In the modern digital landscape, web applications play a crucial role in our daily activities, work, and communication. From e-commerce to educational platforms, these applications empower businesses and individuals alike. Building a successful web application requires creativity, technical expertise, and a deep understanding of user needs.
          \n
          Web development is a blend of front-end and back-end technologies. The front-end focuses on user-facing elements, delivering engaging and intuitive interfaces that captivate and inform.`,
      servicesSection: `Whether you need a sleek landing page or a complex e-commerce platform, we offer comprehensive web development solutions. Our expertise spans full-stack development, ensuring both robust back-end functionality and intuitive front-end interfaces. Our websites don’t just look great—they perform flawlessly, driving conversions and delivering measurable results.
          \n
          On the back-end, we manage the critical logic, data handling, and security that power your application. Using technologies like Python, PHP, Ruby, and Java, along with databases such as MySQL, PostgreSQL, and MongoDB, we build efficient, scalable solutions that ensure reliability and performance.`,
    },
  },
  {
    id: 6,
    img1: require("./assets/services-details/rpa1.webp"), 
    img2: require("./assets/services-details/rpa2.webp"), 
    title: "Robotic Process Automation",
    smallPara:
      "Robotic Process Automation (RPA) is a technology that uses software robots to automate repetitive and rule-based tasks. By mimicking human actions, RPA can streamline workflows, reduce errors, and improve efficiency across various business processes.",
    keyBenefits: [
      "Automation of repetitive and time-consuming tasks.",
      "Improved accuracy and reduced human errors.",
      "Enhanced productivity and operational efficiency.",
      "Scalable solutions for business growth.",
    ],
    detailsPageContent: {
      firstPara: `Robotic Process Automation (RPA) is transforming the way businesses operate by automating repetitive and rule-based tasks. By using software robots to mimic human actions, RPA can streamline workflows, reduce errors, and improve efficiency across various business processes.
          \n
          Our RPA services focus on identifying and automating tasks that are repetitive, time-consuming, and prone to human error. Whether you need to automate data entry, invoice processing, or customer onboarding, we have the expertise to deliver RPA solutions that enhance your operations.`,
      servicesSection: `We offer comprehensive RPA services, including process assessment, bot development, and deployment. Our team is experienced in using leading RPA tools, such as UiPath, Automation Anywhere, and Blue Prism, to create customized automation solutions that meet your specific needs.
          \n
          Our services include RPA strategy development, process optimization, and ongoing support. We work closely with you to identify opportunities for automation and deliver solutions that improve efficiency, reduce costs, and drive business growth.`,
    },
  },
  {
    id: 7,
    img1: require("./assets/services-details/uiux1.webp"), 
    img2: require("./assets/services-details/uiux1.webp"), 
    title: "UX/UI Design",
    smallPara:
      "User Experience (UX) and User Interface (UI) design are critical components of creating engaging and intuitive digital products. UX focuses on the overall experience of the user, while UI deals with the visual and interactive elements of the product.",
    keyBenefits: [
      "User-centric design for better engagement.",
      "Intuitive and visually appealing interfaces.",
      "Improved usability and accessibility.",
      "Enhanced customer satisfaction and retention.",
    ],
    detailsPageContent: {
      firstPara: `User Experience (UX) and User Interface (UI) design are essential for creating digital products that are both functional and visually appealing. UX design focuses on understanding user needs and creating seamless experiences, while UI design deals with the visual and interactive elements that users interact with.
          \n
          Our UX/UI design services focus on creating user-centric designs that enhance usability, accessibility, and engagement. Whether you need a website, mobile app, or software interface, we have the expertise to deliver designs that meet your users' needs and exceed their expectations.`,
      servicesSection: `We offer comprehensive UX/UI design services, including user research, wireframing, prototyping, and visual design. Our team is experienced in using design tools such as Figma, Sketch, and Adobe XD to create intuitive and visually appealing interfaces.
          \n
          Our services include UX strategy development, usability testing, and design system creation. We work closely with you to understand your users' needs and deliver designs that enhance their experience, drive engagement, and achieve your business goals.`,
    },
  },
];

// trusted clients
export const clients = [
  {
    id: 1,
    img: client1,
  },
  {
    id: 2,
    img: client2,
  },
  {
    id: 3,
    img: client3,
  },
  {
    id: 4,
    img: client4,
  },
];

// testimonials
export const testimonials = [
  {
    id: 1,
    img: "",
    name: "Aarav Kapoor",
    title: "Founder of TechSphere Innovations",
    description:
      "Syntax Squad went above and beyond to deliver an innovative solution that perfectly matched our vision. Their expertise truly made a difference!",
  },
  {
    id: 2,
    img: "",
    name: "Sanya Mehta",
    title: "CTO of GreenLink Energy Solutions",
    description:
      "Working with Syntax Squad was effortless. Their technical skills and dedication helped us achieve outstanding results, making the entire process smooth and efficient.",
  },
  {
    id: 3,
    img: "",
    name: "Rahul Verma",
    title: "Director of OmniTrade Logistics",
    description:
      "The team at Syntax Squad provided tailored solutions that exceeded our expectations. Their professionalism and innovative mindset make them a standout choice.",
  },
  {
    id: 4,
    img: "",
    name: "Dr. Ananya Gupta",
    title: "CEO of MedEase Technologies",
    description:
      "Syntax Squad transformed our platform into a seamless and user-friendly experience. Their passion and expertise were evident in every step of the process.",
  },
];


// industry company serve
export const industriesCompanyServe = [
  {
    id: 1,
    title: "Healthcare",
    img: require("./assets/industries/Healthcare.webp"),
    desc: "Transforming patient care and operations with AI-powered diagnostics, data analytics, and telemedicine solutions.",
  },
  {
    id: 2,
    title: "Retail",
    img: require("./assets/industries/E-commerce & Retail.webp"),
    desc: "Enhancing customer experiences with personalized recommendations, inventory management, and secure online transactions.",
  },
  {
    id: 3,
    title: "Fintech",
    img: require("./assets/industries/Fintech.webp"),
    desc: "Streamlining financial services with AI-driven fraud detection, automated customer support, and predictive analytics.",
  },
  {
    id: 4,
    title: "Insurance",
    img: require("./assets/industries/Insurance.webp"),
    desc: "Improving risk assessment, claims processing, and customer engagement through advanced analytics and AI solutions.",
  },
  {
    id: 5,
    title: "Hospitality",
    img: require("./assets/industries/Hospitality.webp"),
    desc: "Enhancing guest experiences with smart booking systems, personalized services, and efficient resource management.",
  },
  {
    id: 6,
    title: "Manufacturing",
    img: require("./assets/industries/Manufacturing.webp"),
    desc: "Driving automation, predictive maintenance, and operational efficiency with AI, machine learning, and IoT technologies.",
  },
  {
    id: 7,
    title: "On Demand",
    img: require("./assets/industries/On Demand.webp"),
    desc: "Empowering on-demand platforms with intelligent matchmaking, real-time tracking, and user-centric analytics.",
  },
  {
    id: 8,
    title: "Food & Restaurant",
    img: require("./assets/industries/Food & Restaurant.webp"),
    desc: "Optimizing food services with smart inventory, personalized menus, and efficient order management solutions.",
  },
  {
    id: 9,
    title: "Logistics",
    img: require("./assets/industries/Logistics & Supply Chain.webp"),
    desc: "Enhancing logistics, inventory, and supply chain management with AI and IoT-enabled tracking and optimization.",
  },
  {
    id: 10,
    title: "Education",
    img: require("./assets/industries/Education.webp"),
    desc: "Personalized learning experiences, predictive analytics for student outcomes, and automated administrative processes using AI and ML.",
  },
  {
    id: 11,
    title: "Game",
    img: require("./assets/industries/Game.webp"),
    desc: "Elevating game development with AI-enhanced graphics, player behavior analytics, and immersive experiences.",
  },
];


// web development portfolio
export const webPortfolio = [
  {
    id: 1,
    title: "5G Homes",
    image: require("./assets/portfolio/web development/5ghomes.webp"),
  },
  {
    id: 2,
    title: "Autopilot",
    image: require("./assets/portfolio/web development/Autopilot.png"),
  },
  {
    id: 3,
    title: "Bayut",
    image: require("./assets/portfolio/web development/bayut.webp"),
  },
  {
    id: 4,
    title: "Cold Creekcap",
    image: require("./assets/portfolio/web development/cold creekcap.webp"),
  },
  {
    id: 5,
    title: "College Nutritionist",
    image: require("./assets/portfolio/web development/collegenutritionist.png"),
  },
  {
    id: 6,
    title: "Leadership.net",
    image: require("./assets/portfolio/web development/leadership.net.png"),
  },
  {
    id: 7,
    title: "Menissa Caterings",
    image: require("./assets/portfolio/web development/menissa caterings.webp"),
  },
  {
    id: 8,
    title: "Think Reality",
    image: require("./assets/portfolio/web development/think reality.webp"),
  },
];

// app development portfolio
export const appPortfolio = [
  {
    id: 1,
    title: "Cryptopadie",
    image: require("./assets/portfolio/app development/cryptopadie.png"),
  },
  {
    id: 2,
    title: "Doctor Plus",
    image: require("./assets/portfolio/app development/doctorplus.png"),
  },
  {
    id: 3,
    title: "Dubai Travel Guide",
    image: require("./assets/portfolio/app development/dubai travel guide.webp"),
  },
  {
    id: 4,
    title: "Elora Hair Palour",
    image: require("./assets/portfolio/app development/elora hair palour.webp"),
  },
  {
    id: 5,
    title: "Evans Francis",
    image: require("./assets/portfolio/app development/evans francis.webp"),
  },
  {
    id: 6,
    title: "House of Deliverance",
    image: require("./assets/portfolio/app development/house of deliverance.png"),
  },
  {
    id: 7,
    title: "MyBitsShop",
    image: require("./assets/portfolio/app development/mybitsshop.webp"),
  },
  {
    id: 8,
    title: "Namaz",
    image: require("./assets/portfolio/app development/namaz.webp"),
  },
  {
    id: 9,
    title: "Potea",
    image: require("./assets/portfolio/app development/potea.webp"),
  },
  {
    id: 10,
    title: "Rentop",
    image: require("./assets/portfolio/app development/rentop.png"),
  },
];